import React, { useState } from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import withMobileDialog from "@material-ui/core/withMobileDialog"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import { Button, Box, Typography } from "@material-ui/core/"
import { closeDeletingPostDialog } from "actions/deleting-post-dialog"
import { useDispatch } from "react-redux"
import DialogsContainerDialog from "../DialogsContainer"
import { deletePost } from "actions/posts"
import { openSnackBar } from "actions/snack-bar"
import LoaderButton from "../../components/LoaderButton"

const DeletingPostDialog = ({ fullScreen, classes, open, data }) => {
  const dispatch = useDispatch()
  const [working, setWorking] = useState(false)

  const handleClose = () => {
    dispatch(closeDeletingPostDialog())
  }
  const handleDelete = () => {
    setWorking(true)
    dispatch(deletePost(data.id))
      .then(res => {
        setWorking(false)
        dispatch(closeDeletingPostDialog())
        dispatch(openSnackBar({ message: "Post Deleted" }))
      })
      .catch(err => {
        setWorking(false)
        dispatch(openSnackBar({ message: "Error deleting post" }))
      })
  }

  return (
    <DialogsContainerDialog
      open={open}
      handleClose={handleClose}
      title="Remove this post?"
      content={
        <Typography variant="caption" className={classes.textExplanation}>
          This will permenantly remove this post. Are you sure you want to
          delete it?
        </Typography>
      }
      buttons={
        <Box display="flex">
          <Button
            variant="text"
            className={classes.cancelButton}
            onClick={handleClose}
          >
            cancel
          </Button>
          <LoaderButton
            classes={{ button: classes.deleteButton }}
            onClick={handleDelete}
            working={working}
          >
            remove
          </LoaderButton>
        </Box>
      }
      fullScreen={false}
    />
  )
}

const mapStateToProps = state => {
  return {
    open: state.deletingPostDialog.open,
    data: state.deletingPostDialog.data
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles),
  withMobileDialog()
)(DeletingPostDialog)



// WEBPACK FOOTER //
// ./src/dialogs/DeletingPost/index.jsx